import { TerminalType } from '../../common/types';
import ebdcoms from '../ebdcoms';
import { StyleConfigAttrs } from './types';
import { getMarginForHeight } from './utils';

export function formatImgUrl(background: any) {
  if (background?.backgroundImage) {
    const imgUrl = background?.imgUrl || '';
    // 路径存在域名时直接使用原路径
    const url = /^https?/.test(imgUrl) ? imgUrl : ebdcoms.excu('getImgPreviewPath')(imgUrl);
    background = {
      ...background,
      backgroundImage: `url(${url})`,
      imgUrl: url,
    };
  }

  return background;
}

const getStyles = (styleConfig: StyleConfigAttrs, clientType?: TerminalType) => {
  const {
    width, margin: marginCfg, padding: paddingCfg, height, background,
  } = styleConfig;

  const padding = paddingCfg?.space && paddingCfg?.selectedId !== 'default'
    ? ebdcoms.excu('parseMPSpace')(paddingCfg?.space, 'padding')
    : {};
  const margin = marginCfg?.space
    ? ebdcoms.excu('parseMPSpace')(marginCfg?.space, 'margin')
    : { margin: 'auto' };

  const marginNum = getMarginForHeight(margin);
  const _height = height || (marginNum === 'auto' ? '100%' : `calc(100% - ${marginNum})`);

  const cssProperties = {
    ...styleConfig,
    width: width || (marginCfg?.space && 'auto'),
    ...padding,
    ...margin,
    ...formatImgUrl(background),
  };

  /**
   * 移动端没有高度配置入口，但是配置了Margin的话，要设置一下高度
   */
  if (clientType === 'PC' || (clientType === 'MOBILE' && !height && marginNum)) {
    cssProperties.height = _height;
  }

  return ebdcoms.excu('parseAttrToCss')(cssProperties);
};

/** 初始化页面样式并返回页面class */
export function initFlowPageStyle(
  styleConfig?: StyleConfigAttrs,
  pageId?: string,
  clsName?: string,
  clientType?: TerminalType,
) {
  const time = Date.now();
  const pageCssAttrs = getStyles(styleConfig || {}, clientType);

  ebdcoms.excu('createCssText')(
    clsName,
    pageCssAttrs,
    false,
    undefined,
    `#ebpage_${pageId}`,
    time,
    clsName,
    'ebd_page',
  );
}

export default {};
